export const TERMSANDCONDITIONS_REQUEST = "TERMSANDCONDITIONS_REQUEST";
export const TERMSANDCONDITIONS_RECEIVE = "TERMSANDCONDITIONS_RECEIVE";
export const TERMSANDCONDITIONS_FAILURE = "TERMSANDCONDITIONS_FAILURE";
export const RESET_TEST = "RESET_TEST";
